import { createRouter, createWebHistory } from "vue-router"

import Panel from "@/components/page-panel/Panel.vue";
import Config from "@/components/page-config/Config.vue";
import Sample from "@/components/Sample.vue";

const routeInfos = [
  // {
  //   // path: "*",
  //   path: "/:catchAll(.*)",
  //   name: "NotFound",
  //   component: Panel,
  //   props: route => ({
  //     locale: route.query.locale,
  //   })
  // },
  {
    path: "/e93cf8730nd11z7gepkly2gry5kv8k/:version/:hash/panel.html",
    name: "panel",
    component: Panel,
    props: route => ({
      locale: route.query.locale,
    })
  },
  {
    path: "/panel.html",
    name: "panel-home",
    component: Panel,
    props: route => ({
      locale: route.query.locale,
    }),
  },
  {
    path: "/e93cf8730nd11z7gepkly2gry5kv8k/:version/:hash/config.html",
    component: Config,
    name: "config",
    props: route => ({
      page: "config",
    })
  },
  {
    path: "/config.html",
    query: route => ({
      state: route.query.state,
    }),
    component: Config,
    name: "config-home",
    props: route => ({
      page: "config",
    }),
  },
  {
    path: "/e93cf8730nd11z7gepkly2gry5kv8k/:version/:hash/liveconfig.html",
    component: Config,
    name: "liveconfig",
    props: route => ({
      page: "live-config",
    })
  },
  {
    path: "/liveconfig.html",
    component: Config,
    name: "liveconfig-home",
    props: route => ({
      page: "live-config",
    })
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes: routeInfos
})

export default router;